var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-sidenav",class:{open: _vm.currentDamSelected},style:(_vm.styleObject),attrs:{"id":"rightSideNav"}},[_c('RightPanelContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }